<p-toast position="top-right"></p-toast>
<router-outlet />